export const DEBOUNCE_SEARCH_DELAY_MS: number = 500;
export const DATE_ISO_FORMAT = 'YYYY-MM-DD';
export const DATE_INPUT_LONG_FORMAT = 'ddd[,] MMM D YYYY';
export const DATE_LONG_FORMAT = 'MMMM DD[,] YYYY hh:mm A';
export const DATE_FORMAT = 'MMM D[,] YYYY';
export const TIME_FORMAT = 'hh:mm A';
export const DATE_TIME_FORMAT = 'MMM D[,] YYYY hh:mm A';
export const CCP_ANIMATION_DURATION = 0.3;
export const ALPHABETICAL_REGEX = '^[a-z, A-Z, \\s]+$';
export const ALPHABETICAL_NUMERICAL_REGEX = '^[a-z,A-Z,0-9, \\s]+$';
export const INPUT_DATE_FORMAT = 'mm/dd/yyyy';
export const EMPTY_LINE = '<p><br></p>';
export const NON_SEARCHABLE_ITEM_VALUE = 'Non-searchable';
